import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=65563b56&"
import script from "./Onboarding.vue?vue&type=script&lang=ts&"
export * from "./Onboarding.vue?vue&type=script&lang=ts&"
import style0 from "./Onboarding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65563b56')) {
      api.createRecord('65563b56', component.options)
    } else {
      api.reload('65563b56', component.options)
    }
    module.hot.accept("./Onboarding.vue?vue&type=template&id=65563b56&", function () {
      api.rerender('65563b56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Onboarding.vue"
export default component.exports